import { schema, NormalizedSchema } from "normalizr";

import { CardCollection, LayerCollection, LayoutState, PageCollection, PageEntity } from "./typings";
import { FarmEntity, SiteEntity } from "../farms";

const layer = new schema.Entity("layer", {});

const card = new schema.Entity("card", {
  layers: new schema.Array(layer)
});

const page = new schema.Entity("page", {
  cards: new schema.Array(card)
});

const farmLayout = new schema.Array(page);

const layout = new schema.Object({
  tabs: new schema.Array(page)
});

export type NormalizedLayout = NormalizedSchema<
  {
    layer: LayerCollection;
    card: CardCollection;
    page: PageCollection;
  },
  {
    key: "main" | FarmEntity["id"] | SiteEntity["id"];
    tabs: PageEntity["id"][];
  }
>;

export type NormalizedPage = NormalizedSchema<
  {
    page: PageCollection;
    layer: LayerCollection;
    card: CardCollection;
  },
  PageEntity["id"]
>;

export default {
  farmLayout,
  layout,
  page,
  card
};
